"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchGames = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var useSearchGames = function (_a) {
    var successAction = _a.successAction, _b = _a.canRender, canRender = _b === void 0 ? true : _b;
    var _c = (0, useMutation_1.useMutation)({
        path: keys_1.GAMES_SEARCH,
        canRender: canRender,
        successAction: function (data) {
            successAction === null || successAction === void 0 ? void 0 : successAction(data);
        },
    }), mutate = _c.mutate, data = _c.data, error = _c.error, isSubmitting = _c.isSubmitting;
    return (0, react_1.useMemo)(function () { return ({
        data: data,
        searchGames: mutate,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [data, mutate, isSubmitting, error]);
};
exports.useSearchGames = useSearchGames;
